export const prop = {
  HEADLINE:           'HEADLINE',
  TITLE:              'TITLE',
  DATE_CREATED:       'DATE_CREATED',
  DATE_MODIFIED:      'DATE_MODIFIED',
  CREATED_BY:         'CREATED_BY',
  MODIFIED_BY:        'MODIFIED_BY',
  STATUS:             'STATUS',
  APPROVED_GRAPHICS:  'APPROVED_GRAPHICS',
  APPROVED_EDITOR:    'APPROVED_EDITOR',
  TARGETS:            'TARGETS'
};

export const order = {
  ASCENDING:  'ASCENDING',
  DESCENDING: 'DESCENDING'
};
